import { networkMap } from "src/helpers/switch-network";
import { Networks, DEFAULD_NETWORK } from "../../../constants/blockchain";

export const getMainnetURI = (): string => {
    return networkMap[DEFAULD_NETWORK].rpcUrls[0];
};
